import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "edit-avatar__container" }
const _hoisted_2 = { class: "edit-avatar__avatar" }
const _hoisted_3 = {
  key: 0,
  class: "edit-avatar__loader"
}
const _hoisted_4 = { ref: "form" }
const _hoisted_5 = { class: "modal-edit-avatar__default-avatar" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "m-top-15 c-primary-grey" }, "The file should be an image", -1)
const _hoisted_7 = { class: "edit-avatar__buttons" }
const _hoisted_8 = { class: "edit-avatar__buttons--nav" }
const _hoisted_9 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cropper = _resolveComponent("cropper")!
  const _component_IconDefaultAvatar = _resolveComponent("IconDefaultAvatar")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    class: "modal-edit-avatar",
    disabledClose: true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.loader)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3))
            : _createCommentVNode("", true),
          (_ctx.avatar?.profile_picture)
            ? (_openBlock(), _createBlock(_component_cropper, {
                key: 1,
                ref: "cropper",
                src: _ctx.avatar?.profile_picture,
                checkOrientation: false,
                checkCrossOrigin: true,
                stencilComponent: _ctx.CircleStencil,
                minWidth: 150,
                minHeight: 150,
                onReady: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loader = false)),
                onChange: _ctx.handleCropperChange
              }, null, 8, ["src", "stencilComponent", "onChange"]))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("div", {
            class: _normalizeClass(["edit-avatar__avatar--input", { 'drag-n-drop': _ctx.showDragNDrop }]),
            onDragenter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showDragNDrop = true)),
            onDragleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showDragNDrop = false)),
            onDrop: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showDragNDrop = false))
          }, [
            _createElementVNode("form", _hoisted_4, [
              _createElementVNode("input", {
                type: "file",
                ref: "input",
                accept: "image/*",
                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.uploadFile && _ctx.uploadFile(...args)))
              }, null, 544)
            ], 512),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_IconDefaultAvatar),
              _hoisted_6
            ])
          ], 34), [
            [_vShow, !_ctx.avatar?.profile_picture]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            class: "btn border mini medium",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.uploadLocalImage && _ctx.uploadLocalImage(...args)))
          }, _toDisplayString(_ctx.avatar?.profile_picture ? 'Change photo' : 'Upload new photo'), 1),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              class: "btn border mini small m-right-10",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            }, "Cancel"),
            _createElementVNode("button", {
              class: "btn fill mini small",
              disabled: _ctx.disabledSave,
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
            }, "Save", 8, _hoisted_9)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}